import { env } from "@shared/config.ts";

export function buildFileStoreUrl(documentPath: string): string {
  const baseUrl = `${env.API_OLD_BASE_URL}/filestore`;
  return `${baseUrl}${documentPath}`;
}
